import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import { HomepageCardBackgroundGradient } from 'connect-dot-com-ui-components/Components/CUIHomepageCard/utils/backgroundGradients';
import { CUIStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import { generateTextGradientFill } from 'connect-dot-com-ui-components/theme/gradients';
import { generateBasicSpacingBreakpointObject } from 'connect-dot-com-ui-components/utils/layout';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import LoginButton from '../AuthButtons/LoginButton';
import SignupButton from '../AuthButtons/SignupButton';
import CommunitiesLayout from '../layout/Communities/CommunitiesLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CommunitiesPage() {
  const textGradientOptions = Object.assign({}, generateTextGradientFill(HomepageCardBackgroundGradient.kyotoCarnaby));
  return /*#__PURE__*/_jsxs(CommunitiesLayout, {
    children: [/*#__PURE__*/_jsx(CUIHeading, {
      variant: "taglineTwo",
      as: "h2",
      marginBottom: 3,
      lineHeight: 1.25,
      color: "GREYSCALE.DARK_MATTER",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "app.communities.header_jsx",
        elements: {
          GradientText: CUIText,
          br: 'br'
        },
        options: {
          textGradientOptions
        }
      })
    }), /*#__PURE__*/_jsx(CUIText, {
      textAlign: "center",
      color: "GREYSCALE.DARK_MATTER",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.communities.bodyCopy"
      })
    }), /*#__PURE__*/_jsxs(CUIStack, {
      direction: ['column', 'row'],
      mt: 14,
      gap: 4,
      minW: generateBasicSpacingBreakpointObject(0, 768),
      children: [/*#__PURE__*/_jsx(LoginButton, {
        variant: "primary",
        width: "100%",
        fontSize: "xl",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.forms.waitlist.login"
        })
      }), /*#__PURE__*/_jsx(SignupButton, {
        width: "100%",
        fontSize: "xl",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.forms.waitlist.signup"
        })
      })]
    })]
  });
}